import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { urlServer } from '../global_constants';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ContactService {
  token: string | null;
  contactsSubject : Subject<any>;
  contactSubject : Subject<any>;
  newContactSubject : Subject<any>;
  editContactSubject : Subject<any>;

  pathApiNewContact = '/v1/contact';
  urlRequestNewContact = urlServer + this.pathApiNewContact;

  pathApiContacts = '/v1/contacts';
  urlRequestContacts = urlServer + this.pathApiContacts;

  pathApiContactDetail = '/v1/contact';
  urlRequestContactDetail = urlServer + this.pathApiContactDetail;  
  
  pathApiEditContact = '/v1/contacts/contact/';
  urlRequestEditContact = urlServer + this.pathApiEditContact;


  constructor(private httpClient: HttpClient) {
    this.contactSubject = new Subject();
    this.contactsSubject = new Subject();
    this.newContactSubject = new Subject();
    this.editContactSubject = new Subject();
    this.token = localStorage.getItem('token') || sessionStorage.getItem('token');
  }

  createNewContact(contactData: any) {
    this.newContactSubject = new Subject();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + this.token);
    this.httpClient.post(this.urlRequestNewContact, contactData, { headers }).subscribe(
      (response: any) => {
        this.newContactSubject.next(response);
        this.newContactSubject.complete();
      },
      (error) => {
        console.error('Error creating a new contact:', error);
      }
    );
  }

  getAllContacts(){
    this.contactsSubject = new Subject();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + this.token);
    this.httpClient.get(this.urlRequestContacts,{headers}).subscribe((response: any) => {
      this.contactsSubject.next(response);
      this.contactsSubject.complete();
    },error => {
      console.error('Error retrieving list contacts:', error);
    });
  } 
 
  getContactDetail(uuid: string): Observable<any> {
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + this.token);
    const url = `${this.urlRequestContactDetail}/${uuid}`;
    return this.httpClient.get(url, { headers });
  }

  // updateContact(uuid : string, body : any) {
  //   this.editContactSubject = new Subject();
  //   let header: HttpHeaders = new HttpHeaders();
  //   header = header.set('authorization', "Bearer "+this.token );
  //   this.httpClient.patch(this.urlRequestEditContact+uuid, body,{headers: header}).subscribe((response: any) => {
  //       this.editContactSubject.next(response);
  //       this.editContactSubject.complete();
  //   },
  //     error => {
  //       console.error('There was an error!', error);
  //     }
  //   );
  // }
  updateContact(uuid: string, body: any): Observable<any> {
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', 'Bearer ' + this.token);
    return this.httpClient.patch(this.urlRequestEditContact + uuid, body, { headers: header });
  }

}
